/**
 * Pagination wrapper that only renders when the total exceeds one page.
 */
import React, { useState } from "react";
import PropTypes from "prop-types";

import BPagination from "./BPagination";

/**
 * Stateful pagination that reports page and page-size changes to the parent.
 *
 * @param {{ total: number, handlePageChange: Function, initPage?: number, initSize?: number }} props
 */
const BGPagination = (props) => {
  const { total, handlePageChange, initPage = 0, initSize = 10 } = props;

  const [page, setPage] = useState(initPage);
  const [pageSize, setPageSize] = useState(initSize);

  /**
   * Updates the current page and notifies the parent.
   *
   * @param {number} page Zero-based page index.
   * @returns {void}
   */
  const onChangePage = (page) => {
    setPage(page);
    handlePageChange(page, window.pageSize || initSize);
  };
  /**
   * Updates rows-per-page and stores it on `window.pageSize`.
   *
   * @param {number} pageSize Rows per page.
   * @returns {void}
   */
  const onPerRowsChange = (pageSize) => {
    window.pageSize = pageSize;
    setPageSize(pageSize);
  };

  return <>{total && total > 10 ? <BPagination currentPage={page} rowsPerPage={pageSize} rowCount={total} paginationRowsPerPageOptions={[10, 20, 50]} onChangePage={onChangePage} onChangeRowsPerPage={onPerRowsChange} /> : <></>}</>;
};

BGPagination.propTypes = {
  total: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired,
  initPage: PropTypes.number,
  initSize: PropTypes.number,
};

export default BGPagination;
